import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

//Styles
import "./IndustrialSection.css";

//Context
import { NavbarContext } from "../../context/NavbarContext";

const IndustrialSection = () => {
  const { industrial } = useContext(NavbarContext);

  const { t } = useTranslation();

  return (
    <section
      ref={industrial}
      className="industrial-section-container"
      id="industrial"
    >
      <img
        className="industrial-bg"
        src="https://pagina-otacc.s3.amazonaws.com/pages/otacc-page/assets/home-bgs/home-bg-4.webp"
        alt="Imagen de fondo de la sección de proyects industriales."
      />
      <div className="industrial-btn-container">
        <Link
          to="/oil-and-gas"
          className="industrial-btn"
          title="Plantas industriales"
        >
          {t("home.button_text")}
        </Link>
      </div>
    </section>
  );
};

export default IndustrialSection;
